<template>
  <div class="page-add">
    <div class="add-title">编辑临时用户</div>
    <base-form formType="edit"></base-form>
  </div>
</template>

<script>
import BaseForm from "@/views/user/addTemporary/baseForm.vue";

export default {
  components: { BaseForm },
  created() {

  },
  methods:{
  },

};
</script>

<style lang="scss" scoped>

</style>
